import { AtHeader, AtClickable, AtDropdown } from '@/components/atoms';
import {
  EClickableVariants,
  EClickableTypes,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { IControlInputProps } from './types';

export const FloorplanSelects = ({
  configMap,
  filterValues,
  setFilter,
  onReset,
  setWereFiltersUsed,
}: IControlInputProps) => {
  if (!configMap) return null;
  // Always render dropdowns, even if config/options are missing, and handle multi-select values like ExteriorStyle
  return (
    <div>
      <div className="flex justify-between">
        <AtHeader className="mb-4" variant="h6">
          Find a Floorplan
        </AtHeader>
        <div className="block sm:hidden">
          <AtClickable
            variant={EClickableVariants.PRIMARY}
            onClick={onReset}
            label="Reset Filters"
            type={EClickableTypes.LINK}
            interactLocation="house-plan-controls"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-[1.5fr_1.5fr_2fr]">
        {['Bedrooms', 'Stories', 'SquareFeet'].map((key) => {
          const config = configMap[key];
          // Always render the dropdown, even if config/options are missing
          const isMulti = !!config?.multi;
          const rawValue = filterValues[key];
          // Use same value normalization as ExteriorStyle
          const value: string | string[] = isMulti
            ? Array.isArray(rawValue)
              ? rawValue.filter((v): v is string => typeof v === 'string')
              : typeof rawValue === 'string'
                ? [rawValue]
                : []
            : typeof rawValue === 'string'
              ? rawValue
              : '';

          return (
            <AtDropdown
              backgroundColor={
                (isMulti ? Array.isArray(value) && value.length > 0 : !!value)
                  ? 'bg-skin-primary'
                  : 'bg-transparent'
              }
              isMulti={isMulti}
              key={key}
              hasBorder
              icon={config?.icon}
              label={config?.label || key}
              options={config?.options ?? []}
              value={value}
              onChange={(val) => {
                const newValue = isMulti
                  ? Array.isArray(val)
                    ? val
                    : [val]
                  : val;
                setFilter(key, newValue);
                setWereFiltersUsed(true);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
